import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  GET_USER,
  UPDATE_PROFILE_AUTH_USER
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  initURL: '',
  isLogged: localStorage.getItem ('userId') ? true : false,
  userId: localStorage.getItem ('userId'),
  authUser: {}
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        isLogged: true,
        userId: action.payload.id,
        authUser: action.payload
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        userId: null,
        authUser: {},
        initURL: '/',
        loader: false,
        isLogged: false
      }
    }
    case GET_USER: {
      return {
        ...state,
        authUser: authUser ? authUser : null
      }
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    case UPDATE_PROFILE_AUTH_USER: {
      let user = state.authUser
      Object.keys(action.payload).map(function (objectKey) {
        const value = action.payload[objectKey]
        user[objectKey] = value
      });

      return {
        ...state,
        authUser: user
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/Auth.js